import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Price } from '@thd-olt-component-react/price';
import { AddToCart } from '@thd-olt-component-react/add-to-cart';
import { CheckAvailability } from '@thd-olt-component-react/check-availability';
import { Col, Row } from '@thd-olt-component-react/grid';
import { DeliveryMessage } from './appliances/DeliveryMessage';
import './Buybox.style.scss';

const Buybox = ({
  cartOptions,
  cartReqParams,
  finalPriceMessage,
  itemId,
  message,
  onAddToCartClick,
  pricing,
  strikethrough,
  applianceBundle,
  showCheckAvailability,
  checkedItems
}) => {

  const { channel } = useContext(ExperienceContext);
  const shouldShowFinalPriceMessage = finalPriceMessage && !applianceBundle;
  const shouldShowStrikethrough = strikethrough && !applianceBundle;
  const [checkAvailabilityDisableATC, setDisable] = useState(false);
  const [availabilityResponse, setAvailabilityResponse] = useState(null);

  const attachAvailabilityRefetch = (callbackData) => {
    const { hasOutOfStock, isUnavailable } = callbackData.processedData;
    setAvailabilityResponse(callbackData);
    if (hasOutOfStock || isUnavailable) {
      setDisable(true);
    } else {
      setDisable(false);
    }
  };

  useEffect(() => {
    if (availabilityResponse && availabilityResponse.refetch) {
      const zip = window.cookieUtils?.readBrowserCookie?.('THD_AOL');
      availabilityResponse.refetch({ itemIds: checkedItems, zip });
    }
  }, [checkedItems]);

  return (
    <>
      <div className="fbt-buybox__message-price">
        {message
        && (
          <div className="fbt-buybox__message">
            {message.priceMessage}
          </div>
        )}
        <div className="fbt-buybox__price">
          {shouldShowStrikethrough && <span className="fbt-buybox__strikethrough" />}
          <Price
            basic={applianceBundle}
            channel={channel}
            itemId={itemId}
            large={applianceBundle}
            product={pricing}
            displayEachUom={!applianceBundle}
          />
          {applianceBundle && <DeliveryMessage totalPrice={pricing} />}
        </div>
      </div>
      {shouldShowFinalPriceMessage && (
        <div className="fbt-buybox__final-price-message">See Final Price in Cart</div>
      )}
      {showCheckAvailability && (
        <Col nopadding className="fbt-buybox__check-availability">
          <CheckAvailability
            itemIds={checkedItems}
            onSubmitForm={attachAvailabilityRefetch}
            hideInput
            autoCheck
            isBundle
            isMajorAppliance
          />
        </Col>
      )}
      <Col nopadding>
        <AddToCart
          cartOptions={cartOptions}
          cartReqParams={cartReqParams}
          onClick={onAddToCartClick}
          disabled={applianceBundle && checkAvailabilityDisableATC}
          outline
        >
          Add Items to Cart
        </AddToCart>
      </Col>
    </>
  );
};

Buybox.propTypes = {
  applianceBundle: PropTypes.bool,
  cartOptions: PropTypes.objectOf(PropTypes.any).isRequired,
  cartReqParams: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.shape({})
  ]).isRequired,
  finalPriceMessage: PropTypes.bool,
  itemId: PropTypes.string.isRequired,
  message: PropTypes.objectOf(PropTypes.any).isRequired,
  onAddToCartClick: PropTypes.func.isRequired,
  pricing: PropTypes.shape({}).isRequired,
  strikethrough: PropTypes.bool,
  showCheckAvailability: PropTypes.bool,
  checkedItems: PropTypes.arrayOf(PropTypes.string),
};

Buybox.defaultProps = {
  applianceBundle: false,
  finalPriceMessage: false,
  strikethrough: false,
  showCheckAvailability: false,
  checkedItems: [],
};

Buybox.displayName = 'FBTBuybox';

export default Buybox;
